// The Heliview tab credential (a signed, 8-hour session id, not a Microsoft token) survives a tab refresh.
// It is scoped to the Teams user and tenant, so another account in the same client never reuses it.
const key = context => context?.user?.id && context?.user?.tenant?.id ? `heliview.teams.credential:${context.user.tenant.id}:${context.user.id}` : null
const store = () => globalThis.sessionStorage

export function rememberCredential(context, credential, storage = store()) {
  if (key(context)) storage?.setItem(key(context), credential)
}
export function rememberedCredential(context, storage = store()) {
  return key(context) ? storage?.getItem(key(context)) ?? null : null
}
export function forgetCredential(context, storage = store()) {
  if (key(context)) storage?.removeItem(key(context))
}

// A shared channel can include people from another Microsoft organization. Their Heliview
// organization is their own tenant, so the host organization's views are not theirs to open.
export function fromOtherOrganization(context, tenantId) {
  const host = context?.channel?.ownerTenantId
  return Boolean(host && tenantId && host.toLowerCase() !== String(tenantId).toLowerCase())
}
